export default __webpack_public_path__ + "static/media/fam1.513e3af2.png";